import React, { useState, useEffect } from 'react'
import Menu from '@material-ui/core/Menu'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { makeStyles } from '@material-ui/core/styles'
import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import Link from '@material-ui/core/Link'
import { Link as LinkRouter } from 'react-router-dom'
import { userQueries, modulesQueries } from '../graphql/queries/'
import { Typography } from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import * as authService from '../services/auth'
import { useApolloClient } from '@apollo/react-hooks'

const useStyles = makeStyles()

const NavMenu = ({ menuIcon, courseId, forum, children }) => {
  const classes = useStyles()
  const apolloClient = useApolloClient()
  const [anchorEl, setAnchorEl] = useState(null)

  const { data: dataUser } = useQuery(userQueries.GET_USER)
  const [loadModule, { data: dataModule }] = useLazyQuery(modulesQueries.GET_MODULES, { fetchPolicy: "network-only" })

  useEffect(() => {
    loadModule()
  }, [])  // eslint-disable-line

  const icons = {
    expand: ExpandMoreIcon,
    options: MoreVertIcon
  }

  const renderedIcon = icon => {
    const Component = icons[icon]
    return <Component />
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setTimeout(() => {
      authService.onLogout(apolloClient)
      window.location.pathname = '/'
    }, 200)
  }

  let testExist = false
  let forumExist

  if (dataModule) {
    const test = dataModule.modulo.map(item => {
      return (item.grupos || []) ? true : false
    })
    testExist = test.some(item => true === item)

    const currentCourse = dataModule.modulo.find(item => item.cursos.find(curso => curso === courseId))
    forumExist = (currentCourse || {}).forum || false
  }

  return (
    <>
      <IconButton className={classes.menuButton} color="inherit" aria-label="menu" aria-haspopup="true" onClick={handleClick}>
        {renderedIcon(menuIcon)}
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.customMenu}
        dataUser={dataUser || {}}
      >
        <Typography variant="body2">
          <Link component={LinkRouter} to={'/meu-perfil'} className={classes.menuLink}>
            <MenuItem>Meu Perfil</MenuItem>
          </Link>
        </Typography>

        {testExist && (
          <Typography variant="body2" >
            <Link component={LinkRouter} to={'/atividades'} className={classes.menuLink}><MenuItem>Provas e simulados</MenuItem></Link>
          </Typography>
        )}
        <Typography variant="body2" >
          {courseId && forumExist && (
            <Typography variant="body2">
              <Link component={LinkRouter} to={`/forum/${courseId}`} className={classes.menuLink}>
                <MenuItem>Fórum de discussão</MenuItem>
              </Link>
            </Typography>
          )}
        </Typography>
        <Typography variant="body2">
          <Link
            className={classes.menuLink}
            component={LinkRouter}
            to={`/certificados`}                     
          >
            <MenuItem>Certificados </MenuItem>
          </Link>
        </Typography>
        <Typography variant="body2">
          <Link
            className={classes.menuLink}
            component={'a'}
            href={`https://atendimento.manole.com.br/aprimora/?e=${btoa(((dataUser || {}).usuario || {}).email)}`}
            rel="noopener"
            target="_blank"
          >
            <MenuItem>Suporte </MenuItem>
          </Link>
        </Typography>
        <Typography variant="body2">
          <Link href="" className={classes.menuLink}> {/* eslint-disable-here */}
            <MenuItem onClick={(e) => {e.preventDefault(); handleLogout()}}>Sair</MenuItem>
          </Link>
        </Typography>
      </Menu>
    </>
  )
}

NavMenu.defaultProps = {
  toggleMenu: null
}

export default NavMenu
